import {HttpErrorResponse} from '@angular/common/http';
import {translate as t} from '@ngneat/transloco';

export function extractServerError({ status, error }: HttpErrorResponse) {
  if (!status || status >= 500) { return t('genericServerErrorText'); }
  if (typeof error === 'string') { return error; }
  return error?.error?.[0] ?? t('genericServerErrorText');
}
